var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7662",
    d: "M3.3 21h17.475A3.017 3.017 0 0024 17.886a3.214 3.214 0 00-.45-1.593l-8.775-14.7A3.206 3.206 0 0012 0a3.206 3.206 0 00-2.775 1.593L.45 16.293A3.019 3.019 0 000 17.886 3.04 3.04 0 003.3 21z",
    fill: "#ff9500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7663",
    d: "M12 13.614a.933.933 0 01-1.05-1.014l-.15-6.01A1.165 1.165 0 0112 5.431a1.165 1.165 0 011.2 1.159l-.225 5.938A.877.877 0 0112 13.614zm0 3.838a1.389 1.389 0 01-1.425-1.3 1.389 1.389 0 011.425-1.3 1.322 1.322 0 011.35 1.3 1.277 1.277 0 01-1.35 1.3z",
    fill: "#fff"
  })));
}
export default SvgWarningIos;